import React, { useRef, useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';

const defaultSize = 260;

function QRWithForm() {
  const [url, setUrl] = useState('');
  const [logoUrl, setLogoUrl] = useState('');
  const [file, setFile] = useState(null);
  const [logo, setLogo] = useState(null);
  const fileInputRef = useRef(null);
const [descriptor, setDescriptor] = useState('');
  // Carga de archivo local
  const handleFileChange = (e) => {
    const uploaded = e.target.files[0];
    if (uploaded) {
      const reader = new FileReader();
      reader.onload = evt => {
        setLogoUrl('');
        setLogo(evt.target.result);
      };
      reader.readAsDataURL(uploaded);
    }
  };

  // Cargar imagen desde URL
  const handleLogoUrl = () => {
    if (logoUrl && logoUrl.match(/^https?:\/\/.+/)) {
      setLogo(logoUrl);
    } else {
      setLogo(null);
    }
  };

  // Render principal
  return (
    <div style={{
        background: '#fff',
        minHeight: '100vh',
        color: '#111',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
    }}>
      <div style={{
        background: '#fff',
        padding: 32,
        borderRadius: 10,
        boxShadow: '0 2px 12px 0 #0001',
        width: 340,
        maxWidth: '90vw'
      }}>
        <button
            style={{
                position: 'absolute',
                top: 20,
                left: 20,
                background: '#222',
                color: '#fff',
                border: 'none',
                borderRadius: 5,
                padding: '9px 18px',
                fontWeight: 700,
                cursor: 'pointer',
                fontSize: 15
            }}
            onClick={() => window.location.pathname = '/'}
        >
            Regresar
        </button>
        <h2 style={{ color: "#111", textAlign: "center" }}>Generador QR personalizado</h2>
        <input
          style={styles.input}
          value={url}
          onChange={e => setUrl(e.target.value)}
          placeholder="URL para el QR"
        />
        <div style={{marginTop:10}}>
            <input
                style={styles.input}
                placeholder="Texto descriptivo debajo del QR"
                value={descriptor}
                onChange={e => setDescriptor(e.target.value)}
            />
          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
          <button
            type="button"
            style={styles.button}
            onClick={() => fileInputRef.current.click()}
          >
            Cargar imagen desde archivo
          </button>
        </div>
        <div style={{margin: '8px 0'}}>ó</div>
        <div style={{ display:'flex', gap:8 }}>
          <input
            style={styles.input}
            placeholder="URL de imagen central"
            value={logoUrl}
            onChange={e => setLogoUrl(e.target.value)}
          />
          <button type="button" style={{...styles.button, padding: '10px 12px'}} onClick={handleLogoUrl}>
            Agregar imagen al QR
          </button>
        </div>
        <div style={{margin:'22px 0 6px'}}>
          {url &&
            <QRCodeCanvas
              value={url}
              size={defaultSize}
              bgColor="#fff"
              fgColor="#111"
              level="H"
              imageSettings={logo ? {
                src: logo,
                x: undefined,
                y: undefined,
                height: 56,
                width: 56,
                excavate: true
              } : undefined}
            />
          }
        </div>
        {logo &&
          <div style={{ textAlign: "center", fontSize: 12, color: "#888" }}>
            {descriptor && <div style={{marginBottom: 8}}>{descriptor}</div>}
          </div>
        }
      </div>
      <div style={{marginTop: 40, fontSize: 12, color:'#aaa', textAlign:'center'}}>
        Tip: Prepara tu imagen central en blanco y negro/escala de grises antes de cargarla para mejores resultados. El código QR y sus fondos se mantendrán monocromáticos.<br/>
        <strong>Nota:</strong> Por limitaciones del navegador, la imagen central no se convierte automáticamente a escala de grises.
      </div>
    </div>
  );
}

const styles = {
  input: {
    border: "1px solid #333",
    borderRadius: 5,
    padding: "9px 13px",
    fontSize: 15,
    outline: "none",
    marginBottom: 3,
    width: "100%",
    color:'#111',
    background:'#fff'
  },
  button: {
    background: "#222",
    color: "#fff",
    border: "none",
    borderRadius: 5,
    padding: "9px 18px",
    fontWeight: 700,
    cursor: "pointer",
    fontSize: 15
  }
};

export default QRWithForm;
